import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';
import { CampaignAddMembersRequest, CampaignDeleteMembersRequest, CampaignAddMemeberListRequest } from '../models/campaigns';
import { MarketingListAddMembersRequest } from '../models/marketing-lists/marketing-list-add-members-request';
import { MarketingListDeleteMembersRequest } from '../models/marketing-lists/marketing-list-delete-members-request';

@Injectable({
  providedIn: 'root'
})
export class MarketingDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  getMarketingCampaignOptionsAsync(query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('MarketingCampaigns/Options', request, cancellationToken);
  }

  checkMarketingCampaignClinicExistsAsync(marketingCampaignId: number, clinicId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { marketingCampaignId: marketingCampaignId, clinicId: clinicId, id: id };
    return this.httpClient.getJsonAsync<boolean>('MarketingCampaignClinics/CheckMarketingCampaignClinicExists', data, timeout, false);
  }

  checkMarketingCampaignRegionExistsAsync(marketingCampaignId: number, regionId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { marketingCampaignId: marketingCampaignId, regionId: regionId, id: id };
    return this.httpClient.getJsonAsync<boolean>('MarketingCampaignRegions/CheckMarketingCampaignRegionExists', data, timeout, false);
  }

  deleteMarketingCampaignsClinicAsync(id: number, timeout: Promise<any>) {
    return this.httpClient.postJsonAsync('MarketingCampaignClinics/Delete', id, timeout);
  }

  deleteMarketingCampaignsRegionAsync(id: number, timeout: Promise<any>) {
    return this.httpClient.postJsonAsync('MarketingCampaignRegions/Delete', id, timeout);
  }

  checkReferralSourceRegionMarketingCampaignExistsAsync(referralSourceId: number, regionId: number, marketingCampaignId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { referralSourceId: referralSourceId, regionId: regionId, marketingCampaignId: marketingCampaignId, id: id };
    return this.httpClient.getJsonAsync<boolean>('ReferralSourceRegionMarketingCampaigns/CheckReferralSourceRegionMarketingCampaignExists', data, timeout, false);
  }

  deleteMarketingListMembersAsync(memberIds: number[], timeout: Promise<any>): Promise<any> {
    const request: MarketingListDeleteMembersRequest = {
      memberIds: memberIds
    }

    return this.httpClient.postJsonAsync('MarketingLists/DeleteMarketingListMembers', request, timeout);
  }

  addMarketingListMembersAsync(marketingListId: number, patientIds: number[], timeout: Promise<any>): Promise<number> {
    const request: MarketingListAddMembersRequest = {
      patientIds: patientIds,
      marketingListId: marketingListId
    };

    return this.httpClient.postJsonAsync('MarketingLists/AddMarketingListMembers', request, timeout);
  }

  deleteCampaignMembersAsync(memberIds: number[], timeout: Promise<any>): Promise<any> {
    const request: CampaignDeleteMembersRequest = {
      memberIds: memberIds
    }

    return this.httpClient.postJsonAsync('Campaigns/DeleteCampaignMembers', request, timeout);
  }

  addCampaignMembersAsync(campaignId: number, patientIds: number[], timeout: Promise<any>): Promise<any> {
    const request: CampaignAddMembersRequest = {
      patientIds: patientIds,
      campaignId: campaignId
    };

    return this.httpClient.postJsonAsync('Campaigns/AddCampaignMembers', request, timeout);
  }

  addCampaignMembersFromMarketingList(campaignId: number, marketingListId: number, timeout: Promise<any>): Promise<number> {
    const request: CampaignAddMemeberListRequest = {
      campaignId: campaignId,
      marketingListId: marketingListId
    };

    return this.httpClient.postJsonAsync('Campaigns/AddCampaignMembersFromMarketingList', request, timeout);
  }

  getMarketingListOptionsAsync(query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('MarketingLists/options', request, cancellationToken);
  }

  getAllMarketingListOptionsAsync(cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    return this.httpClient.getJsonAsync<ListOption<number>[]>('MarketingLists/GetAllListOptions', {}, cancellationToken);
  }
}
